import type { TintaDaPecaDto } from '@pieltec/contracts';
import { opcoesTinta } from '../material-atributos';

export const ENDPOINT_TINTAS_ELEGIVEIS = '/api/v1/roteiros/tintas/elegiveis';
export const TEXTO_SEM_TINTA_DA_PECA = 'Tinta da peça: não definida. Vale a regra por cor e tipo.';

export function rotuloOrigemTinta(origem: TintaDaPecaDto['origem']): string {
  return origem === 'CARGAMAQUINA' ? 'automático pelo CargaMáquina' : 'escolhida pelo PCP';
}

export function textoTintaDaPeca(tintaDaPeca: TintaDaPecaDto | null): string {
  if (tintaDaPeca === null) return TEXTO_SEM_TINTA_DA_PECA;
  if (tintaDaPeca.tinta === null) return `Tinta da peça: regra por cor e tipo (${rotuloOrigemTinta(tintaDaPeca.origem)})`;
  return `Tinta da peça: ${tintaDaPeca.tinta.codigo} · ${tintaDaPeca.tinta.nome} (${rotuloOrigemTinta(tintaDaPeca.origem)})`;
}

function rotuloTipo(tipo: string): string {
  return opcoesTinta.find((opcao) => opcao.value === tipo)?.label ?? tipo;
}

export function avisosTintaDaPeca(tintaDaPeca: TintaDaPecaDto | null, tipoDaPeca: string | null): string[] {
  const tinta = tintaDaPeca?.tinta;
  if (!tinta) return [];
  if (!tinta.elegivel) return ['Esta tinta está inativa ou fora de kg/litro: o cálculo usa a regra por cor e tipo.'];
  if (tinta.tipoTinta && tipoDaPeca && tinta.tipoTinta !== tipoDaPeca) {
    return [`O tipo da tinta (${rotuloTipo(tinta.tipoTinta)}) é diferente do tipo da peça (${rotuloTipo(tipoDaPeca)}); vale a tinta da peça.`];
  }
  return [];
}
